import { render } from "./MerchantAllSet.vue?vue&type=template&id=e1750ffe"
import script from "./MerchantAllSet.vue?vue&type=script&lang=js"
export * from "./MerchantAllSet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__